import layout from '../layout/index.vue'
import bar from '../bar/index.vue'
import mobilebar from '../mobileBar/index.vue'

/**
 * 无权限，默认渲染的路由
 */
export const constantRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/register/index')
  },
  {
    path: '/forgot-passwd',
    name: 'forgot-passwd',
    component: () => import('@/views/forgot-password/index')
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/login',
    redirect: '/login',
    name: '默认页跳转',
    meta: {
      title: '登陆',
      affix: true
    },
    component: () => import('@/views/login/index')
  }

]

/**
 * 需要根据用户角色动态加载的路由
 */
export const asyncRoutes = [
  {
    path: '/',
    component: layout,
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/file/index'),
        meta: {
          title: '乐家市场',
          icon: 'theme'
        }
      },
      {
        path: 'share-list',
        name: 'share-list',
        component: () => import('@/views/share/share-list'),
        meta: {
          title: '我的分享',
          icon: 'theme'
        }
      },
      {
        path: 'group-list',
        name: 'group-list',
        component: () => import('@/views/group/group-list'),
        meta: {
          title: '管理分组',
          icon: 'theme'
        }
      },
      {
        path: 'user-list',
        name: 'user-list',
        component: () => import('@/views/user/user-list'),
        meta: {
          title: '设备管理',
          icon: 'theme'
        }
      },
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/rom-order/order'),
        meta: {
          title: 'ROM订单',
          icon: 'theme'
        }
      },
      {
        path: 'money',
        name: 'money',
        component: () => import('@/views/money/index'),
        meta: {
          title: '余额管理',
          icon: 'theme'
        }
      },
      {
        path: 'rom-list',
        name: 'rom-list',
        component: () => import('@/views/rom/rom-list'),
        meta: {
          title: 'ROM管理',
          icon: 'theme'
        }
      }
    ]
  }
]

export const constantDefRoutes = [
  {
    path: '/index1',
    component: bar,
    children: [{
      path: '/index',
      name: 'index',
      component: () => import('@/views/index/index'),
      meta: {
        title: '首页',
        icon: 'theme'
      }
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: () => import('@/views/aboutus/index'),
      meta: {
        title: '关于我们',
        icon: 'theme'
      }
    },
    // {
    //   path: '/desktop',
    //   name: 'desktop',
    //   component: () => import('@/views/desktop/index'),
    //   meta: {
    //     title: '乐家桌面',
    //     icon: 'theme'
    //   }
    // },
    {
      path: '/market',
      name: 'market',
      component: () => import('@/views/market/index'),
      meta: {
        title: '乐家市场',
        icon: 'theme'
      }
    },
    {
      path: '/mhome',
      name: 'mhome',
      component: () => import('@/views/index/index'),
      meta: {
        title: '首页',
        icon: 'theme'
      }
    },
    {
      path: '/ljmange',
      name: 'ljmange',
      component: () => import('@/views/index/index'),
      meta: {
        title: '首页',
        icon: 'theme'
      }
    }
    ]
  }
]

export const constantMobileRoutess = [
  {
    path: '/mindex',
    component: mobilebar,
    children: [
      {
        path: '/mindex',
        name: 'mindex',
        component: () => import('@/views/mobile/index/index'),
        meta: {
          title: '首页',
          icon: 'theme'
        }
      },
      {
        path: '/maboutus',
        name: 'maboutus',
        component: () => import('@/views/mobile/aboutus/index'),
        meta: {
          title: '关于我们',
          icon: 'theme'
        }
      },
      // {
      //   path: '/mdestop',
      //   name: 'mdestop',
      //   component: () => import('@/views/mobile/desktop/index'),
      //   meta: {
      //     title: '乐家桌面',
      //     icon: 'theme'
      //   }
      // },
      {
        path: '/mmarket',
        name: 'mmarket',
        component: () => import('@/views/mobile/market/index'),
        meta: {
          title: '乐家市场',
          icon: 'theme'
        }
      }
    ]
  }
]

// 所有上面定义的路由都要写在下面的routers里
export let constRouters = [
  asyncRoutes,
  constantRoutes,
  constantDefRoutes,
  constantMobileRoutess

]



// WEBPACK FOOTER //
// ./src/router/routers.js